import type { PkSummary } from "../../../types/playerPk";
import "../../epicLeaderboard/epicLeaderboard.css";
import "./pk.css";

type Props = {
  summary: PkSummary;
};

const SoloAssistedSplit = ({ summary }: Props) => {
  const { soloKills, assistedKills, kills, soloPct } = summary;
  if (kills === 0) {
    return <div className="pk-card text-center">No kills in this range.</div>;
  }
  const assistedPct =
    soloPct === null ? null : Math.round((100 - soloPct) * 10) / 10;
  return (
    <div className="pk-card">
      <div
        className="pk-split mb-3"
        role="img"
        aria-label={`${soloPct}% solo kills, ${assistedPct}% assisted kills`}
      >
        <div className="pk-split-solo" style={{ width: `${soloPct ?? 0}%` }} />
        <div
          className="pk-split-assisted"
          style={{ width: `${assistedPct ?? 0}%` }}
        />
      </div>
      <div className="d-flex justify-content-between flex-wrap gap-2">
        <div>
          <span
            className="pk-legend-dot"
            style={{ backgroundColor: "rgb(70, 130, 180)" }}
          />
          Solo: <strong>{soloKills.toLocaleString()}</strong>{" "}
          <span className="epic-lb-muted">({soloPct}%)</span>
        </div>
        <div>
          <span
            className="pk-legend-dot"
            style={{ backgroundColor: "rgb(174, 217, 224)" }}
          />
          With help: <strong>{assistedKills.toLocaleString()}</strong>{" "}
          <span className="epic-lb-muted">({assistedPct}%)</span>
        </div>
      </div>
    </div>
  );
};

export default SoloAssistedSplit;
